import { render } from "./BoxManifestTable.vue?vue&type=template&id=41d8735a&scoped=true"
import script from "./BoxManifestTable.vue?vue&type=script&lang=js"
export * from "./BoxManifestTable.vue?vue&type=script&lang=js"

import "./BoxManifestTable.vue?vue&type=style&index=0&id=41d8735a&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d8735a"]])

export default __exports__